/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import Modal from "../components/Modal";

import {
  useDeliveriesStore,
  useLoadingStore,
  useModalStore,
} from "../stores/hooks";

import {
  DELAY_REASONS,
  PICKUP_DELAY_REASONS,
  REASON_ETC,
} from "../utils/delay";
import {
  sendSmsMessageForDirect,
  sendToastMessage,
} from "../utils/postMessages";

const ReasonItem = ({ active, reason, onSelect }) => {
  const handleSelect = () => {
    onSelect(reason);
  };

  return (
    <div>
      <label className="block mb-10 text-16" onClick={handleSelect}>
        <input
          type="radio"
          name="corp"
          defaultChecked={!!active}
          className="mr-5"
        />
        {reason.text}
      </label>
    </div>
  );
};

function DeliveryDelayModal({ delivery, onAfterSubmit, isPickup = false }) {
  const { ...actions } = useDeliveriesStore();

  const { ...loadingActions } = useLoadingStore();

  const { closeModal } = useModalStore();

  const { register, handleSubmit, reset, setValue, watch, setFocus } =
    useForm();

  const [load, setLoad] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const reasons = isPickup ? PICKUP_DELAY_REASONS : DELAY_REASONS;

  useEffect(() => {
    reset({
      code: reasons[0].code,
      text: reasons[0].text,
    });

    setLoad(true);
  }, []);

  // 배송 지연 취소
  const handleCancel = () => {
    closeModal();
  };

  // 사유 선택
  const handleSelectReason = (reason) => {
    setValue("code", reason.code);
    setValue("text", reason.text);
    setValue("etcText", "");
  };

  // 직접입력 전체 삭제
  const handleDeleteEtcText = () => {
    setValue("etcText", "");
  };

  const onSubmit = async ({ code, text, etcText }) => {
    try {
      if (code === REASON_ETC && !etcText) {
        setErrorMessage("기타 사유를 입력해주십시오");
        setFocus("etcText");

        return;
      }

      loadingActions.startLoading();

      const reasonText = `${text}${
        code === REASON_ETC && etcText ? `(${etcText})` : ""
      }`;

      const data = {
        bookId: delivery.bookId,
        reason: reasonText,
        reasonType: code,
      };

      await actions.setDelay(data);

      if (delivery.typeNormal && delivery.isNotFreshCode) {
        const message = `[두발히어로 ${delivery.bookId}]${delivery.spotName} 상품이 ${reasonText} 사유로 배송이 지연되고 있습니다.`;

        sendSmsMessageForDirect({
          mobile: delivery.receiverSmsMobile || delivery.receiverMobile,
          message,
          bookId: delivery.bookId,
        });
      }

      sendToastMessage(
        `${reasonText}, ${isPickup ? "수거지연" : "배송지연"} 사유 등록 완료`,
      );

      onAfterSubmit();
      closeModal();
    } catch (e) {
      window.alert(
        `${isPickup ? "수거지연" : "배송지연"} 사유 등록에 실패했습니다. ${e.message}`,
      );
    }

    loadingActions.finishLoading();
  };
  return (
    <Modal>
      <div className="p-15">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-20">
            <h5 className="font-medium text-18 mb-10">
              {delivery?.bookId}{" "}
              {isPickup
                ? delivery?.senderAddress || delivery?.senderAddressRoad || ""
                : delivery?.receiverAddress ||
                  delivery?.receiverAddressRoad ||
                  ""}{" "}
              {isPickup ? "수거지연" : "배송지연"} 사유를 선택해주세요.
            </h5>
            <div>
              {load &&
                reasons.map((reason) => {
                  return (
                    <ReasonItem
                      key={reason.code}
                      active={reason.code === watch("code")}
                      reason={reason}
                      onSelect={handleSelectReason}
                    />
                  );
                })}
              <input name="code" {...register("code")} hidden />
              <input name="text" {...register("text")} hidden />
              <div className="bg-[#f6f6f6] p-5 flex justify-between items-center ml-10">
                <input
                  type="text"
                  className="bg-transparent max-w-[calc(100vw-120px)] flex-1"
                  {...register("etcText")}
                  disabled={watch("code") !== REASON_ETC}
                  onChange={() => {
                    setErrorMessage("");
                  }}
                />
                <button
                  type="button"
                  className="text-16 text-[#999] p-5 w-50"
                  onClick={handleDeleteEtcText}
                >
                  삭제
                </button>
              </div>
              {errorMessage && (
                <div className="text-red text-12 mb-10 ml-10">
                  {errorMessage}
                </div>
              )}
            </div>
          </div>
          <div className="flex justify-center items-center">
            <button
              type="button"
              className="text-16 flex-1 p-10"
              onClick={handleCancel}
            >
              취소
            </button>
            <button type="submit" className="text-16 text-orange flex-1 p-10">
              확인
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
}

export default DeliveryDelayModal;
